"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsString_1 = __importDefault(require("../../typeAssertions/valueIsString"));
const regexTestBuilder = (isLegacy) => ({ entryVars: { regex, stringToEvalue, basicRegex, }, callbacks, functionId, executeProcesses, }) => {
    if (!(0, valueIsString_1.default)(stringToEvalue)) {
        executeProcesses(functionId, callbacks.onError, 'String to evaluate is not a string');
        return false;
    }
    const regexTester = isLegacy
        ? new RegExp(`^${basicRegex || regex}$`)
        : new RegExp(`${basicRegex || regex}`);
    let flag = false;
    if (stringToEvalue || stringToEvalue === '') {
        flag = regexTester.test(stringToEvalue);
    }
    executeProcesses(functionId, flag ? callbacks.isTrue : callbacks.isFalse, flag);
    return flag;
};
exports.default = regexTestBuilder;
